import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';
import { Box, Button } from '@mui/material';
import { connect } from 'formik';
import { I18n } from 'utils/i18n';

class ActionButtons extends Component {
  handleReset = e => {
    const { onReset, formik } = this.props;
    onReset();
    formik.handleReset(e);
  };

  render() {
    const { formik, isEdit } = this.props;
    return (
      <Box sx={{ display: 'flex', justifySelf: 'flex-end', padding: '20px 0' }}>
        <Button
          variant="outlined"
          onClick={this.handleReset}
          disabled={formik.isSubmitting}
          sx={{ color: 'primary.ultraDark', marginRight: '10px' }}
          type="reset"
          color="secondary"
        >
          {I18n.t('ChannelDrawer.Cancel')}
        </Button>
        <Button variant="contained" disabled={formik.isSubmitting} color="primary" type="submit">
          {formik.isSubmitting
            ? `${
                isEdit
                  ? I18n.t('ChannelDrawer.Updating channel')
                  : I18n.t('ChannelDrawer.Creating channel')
              }...`
            : `${
                isEdit
                  ? I18n.t('ChannelDrawer.Update channel')
                  : I18n.t('ChannelDrawer.Create channel')
              }`}
        </Button>
      </Box>
    );
  }
}

ActionButtons.propTypes = {
  formik: object.isRequired,
  onReset: func.isRequired,
  isEdit: bool.isRequired,
};

export default connect(ActionButtons);
